'use strict';

$(function() {
    $('article iframe[src*="youtu"]').wrap( '<div class="video-wrapper"></div>' );
});
